"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isZeroDurationContent(duration, subType) {
    return duration < 1 && subType !== 'scorm';
}
exports.isZeroDurationContent = isZeroDurationContent;
//# sourceMappingURL=isZeroDurationCard.js.map